import React from "react";
import * as CHQ from "chq";
import { Link } from "react-router-dom";

import { CommentLink, ProfileLink } from "app/links";
import { Trans } from "app/utils";

import LazyEditorOutput from "components/editor/LazyEditorOutput";

import NotificationBody from "./NotificationBody";

type CommentOfInterestNotificationProps = {
  notification: CHQ.NotificationCommentOfInterest;
  tabIndex?: number;
};

export const getEntityCreator = (entity: any) => {
  switch (entity.commentableType) {
    case "Story":
      return entity.commentable.creator;
    case "UserActivity":
      return entity.commentable.entity.creator;
    default:
      return "";
  }
};

export const getEntityTitle = (entity: any) => {
  switch (entity.commentableType) {
    case "Story":
      return entity.commentable.question.question;
    case "UserActivity":
      return entity.commentable.entity.title;
    default:
      return "";
  }
};

const CommentOfInterestNotification: React.FC<CommentOfInterestNotificationProps> = ({
  notification: { actor, entity }, tabIndex
}) => {
  const getEntityLink = () => {
    switch (entity.commentableType) {
      case "Story":
        return (
          <Link to={`/stories/trend/${entity?.commentable.question?.id}/story/${entity?.commentable?.id}`} tabIndex={tabIndex || 0}>
            {entity.commentableType.toLowerCase()}
          </Link>
        );
      case "UserActivity":
        return (<CommentLink comment={entity} tabIndex={tabIndex || 0}>post</CommentLink>);
      default:
        return (<></>);
    }
  };

  const getStroyTrendTitle = () => {
    const { commentable } = entity;
    return (
      <CommentLink comment={entity} tabIndex={tabIndex || 0}>
        {commentable?.entity?.question?.question}
      </CommentLink>
    );
  };

  if (entity.commentableType === "UserActivity" && entity.commentable.activityType === "story_created") {
    return (
      <NotificationBody actor={actor}>
        <ProfileLink user={actor} tabIndex={tabIndex || 0} />
        {" "}
        <Trans>
          also commented on the story trend:
          {" "}
          {getStroyTrendTitle()}
        </Trans>
        <br />
        <br />
        <LazyEditorOutput output={entity.body} tabIndex={tabIndex} />
      </NotificationBody>
    );
  }

  return (
    <NotificationBody actor={actor}>
      <ProfileLink user={actor} tabIndex={tabIndex || 0} />
      {" "}
      <Trans>
        also commented on
        {" "}
        <ProfileLink user={getEntityCreator(entity)} tabIndex={tabIndex || 0} />
        &apos;s
        {" "}
        {getEntityLink()}
        :
        {" "}
        {getEntityTitle(entity)}
      </Trans>
      <br />
      <br />
      <LazyEditorOutput output={entity.body} tabIndex={tabIndex} />
    </NotificationBody>
  );
};

export default CommentOfInterestNotification;
